function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m16 176v-136h-16v144a8 8 0 0 0 8 8h184v-16z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m26.343 122.343 11.314 11.314 6.533-6.533 12.5 28.125a8 8 0 0 0 11.749 3.407l18.541-12.362 19.363 19.363a8 8 0 0 0 13.176-2.923l11.381-31.307 6.587 9.223a8 8 0 0 0 6.513 3.35 7.742 7.742 0 0 0 .774-.038 8 8 0 0 0 6.51-4.651l17.08-37.576 10.636 8.512 10-12.494-13.8-11.044 16.09-35.4-14.566-6.622-14.424 31.713-13.3-10.647a8 8 0 0 0 -12.517 3.513l-10.229 28.126-15.744-22.042a8 8 0 0 0 -13.665 1.072l-11.945 23.895-16.462-10.973a8 8 0 0 0 -10.095 1l-8.994 8.995-10.038-22.588-14.622 6.5 12.538 28.21zm121.365-37.132 7.766 6.213-13.021 28.646-4.917-6.884zm-82.688 21.083 18.543 12.362a8 8 0 0 0 11.592-3.078l10.058-20.116 14.408 20.171-10.847 29.828-15.117-15.118a8 8 0 0 0 -10.094-1l-16.106 10.738-11.146-25.081z"
});

var SvgLineGraph = function SvgLineGraph(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 192 192",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLineGraph, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/line-graph.b4530ed1.svg";
export { ForwardRef as ReactComponent };